import * as React from 'react';
import './Button.scss';

interface Props {
    label: string;
    block?: boolean;
    onClick: () => void;
    disabled?: boolean;
}

export default class Button extends React.Component<Props> {

    handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (!this.props.disabled) {
            this.props.onClick();
        }
    };
    public render() {
        return (
            <button
                className={
                    'button et-button et-button-primary' +
                    (this.props.disabled ? 'disabled ' : '') +
                    (this.props.block ? 'block ' : '')
                }
                onClick={this.handleClick}
                type="submit"
            >{this.props.label}
            </button>
        );
    }
}